import {useEffect, useRef} from 'react';

type ScheduleFn = (action: () => void, delay: number) => void;

// Schedules a deferred action with automatic cleanup on unmount and on re-schedule.
export const useTimeoutAction = (): ScheduleFn => {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // effect:audited — registers an unmount cleanup that clears any pending
  // setTimeout so the scheduled action can't fire after the component unmounts.
  useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    },
    [],
  );

  return (action, delay) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      timeoutRef.current = null;
      action();
    }, delay);
  };
};
